// extracted by mini-css-extract-plugin
module.exports = {"SidebarWrapper":"Sidebar_SidebarWrapper__2thFs"};